module.exports = __webpack_public_path__ + "static/media/list.3b8a2d0a.svg";